module.exports = __webpack_public_path__ + "static/ph-3c40e0291d822d611e7b4f7692648fc2.png";